var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcGeolocationPermission = function SvgIcGeolocationPermission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 60,
    fill: "none",
    viewBox: "0 0 41 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67AEFF",
    fillRule: "evenodd",
    d: "M18.012 41.713a66 66 0 0 1-5.237-5.564C9.22 31.904 5 25.582 5 19.558A15.55 15.55 0 0 1 31.55 8.559a15.45 15.45 0 0 1 4.55 10.999c0 6.024-4.221 12.346-7.775 16.591a66 66 0 0 1-5.238 5.564 3.684 3.684 0 0 1-5.075 0M20.555 26a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 55,
    fill: "#D0D0D9",
    rx: 11,
    ry: 4
  })));
};
export default SvgIcGeolocationPermission;